import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../../components/Button";
import CustomTextField from "../../../components/Textfield";
import { getSx } from "../../../components/Modal/style";
import { useDispatch } from "react-redux";
import UploadImage from "../../../components/UploadImage";
import * as Yup from "yup";
import {
  addFile,
  addSponsor,
  deleteFile,
  updateSponsor,
} from "../../../http/auth";
import { useFormik } from "formik";
import Spinner from "../../../components/Spinner";
import { showToast } from "../../../store/slices/common";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "550px",
    padding: "30px",
    borderRadius: "20px",
  },
  "& .MuiPaper-root": { maxWidth: "550px" },
  "& .MuiDialogActions-root": {},
  "& .MuiDialogContent-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

export default function AddSponsorModal({
  open,
  setOpen,
  sponsor,
  getSponsorList,
  isEdit,
  isView,
  setPage,
}) {
  const [loading, setLoading] = useState(false);
  const classes = getSx(true);
  const dispatch = useDispatch();

  const initialValues = {
    logo: sponsor?.logo || "",
    en: sponsor?.title?.en || "",
    hi: sponsor?.title?.hi || "",
    fr: sponsor?.title?.fr || "",
    es: sponsor?.title?.es || "",
    link: sponsor?.link || "",
  };

  const validationSchema = Yup.object({
    // title: Yup.string().required("Title is required"),
    link: Yup.string().required("Url is required").url("Invalid url"),
    logo: Yup.string().required("Logo is required").url("Invalid url"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        console.log(values);
        setLoading(true);
        const payload = {
          ...values,
          title: {
            en: values?.en,
            hi: values?.hi,
            fr: values?.fr,
            es: values?.es,
          },
        };
        delete payload.hi;
        delete payload.en;
        delete payload.fr;
        delete payload.es;
        const res = isEdit
          ? await updateSponsor({ ...payload, sponsorId: sponsor.id })
          : await addSponsor(payload);
        !isEdit && setPage(1);
        isEdit ? await getSponsorList() : await getSponsorList(1);
        dispatch(showToast({ color: "success", msg: res.data.message?.en }));
        closeModalHandler();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        // dispatch(showToast({ color: "error", msg: error?.response?.data?.message || "Something went wrong" }));
      }
    },
  });

  const closeModalHandler = () => {
    setOpen(false);
  };

  const handleFileUpload = async (file, banner) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = async () => {
          const width = img.width;
          const height = img.height;
          console.log(width, height, "resolution");
          if (width === 220 && height === 220) {
            const res = await addFile(formData);
            formik.setFieldValue("logo", res?.data?.data?.fileUrl);
            dispatch(
              showToast({ color: "success", msg: res.data.message?.en })
            );
          } else {
            dispatch(
              showToast({
                color: "error",
                msg: "Image must be of resolution 220x220",
              })
            );
          }
        };

        img.onerror = () => {
          setError("Failed to load image.");
        };
      }
    } catch (err) {
      console.log(err);
      // dispatch(showToast({ color: "error", msg: "something went wrong" }))
    } finally {
      setLoading(false);
    }
  };

  const handleFileDelete = async () => {
    setLoading(true);
    try {
      const payload = { fileUrl: formik.values.logo };
      const res = await deleteFile(payload);
      dispatch(showToast({ color: "success", msg: res.data.message?.en }));
      formik.setFieldValue("logo", "");
    } catch (err) {
      console.log(err);
      // dispatch(showToast({ color: "error", msg: "something went wrong" }))
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "550px",
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {loading && <Spinner />}
      <form onSubmit={formik.handleSubmit}>
        <DialogContent sx={{ padding: "8px 20px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              minWidth: "300px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            {isEdit ? "Update Sponsor" : "Add Sponsor"}
          </Typography>
          <Box
            display="flex"
            maxWidth="380px"
            flexDirection="column"
            padding={{ xs: "0", md: "0 20px" }}
          >
            {loading && <Spinner />}
            <Box
              sx={{
                height: "fit-content",
                display: "flex",
                justifyContent: "flex-start",
                gap: "2rem",
                overflow: "auto",
                flexWrap: "wrap",
              }}
              className="walkthrough"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "8px",
                  width: "100%",
                }}
              >
                <UploadImage
                  style={{
                    height: "120px",
                    width: "150px",
                    iconWidth: "32px",
                    iconHeight: "32px",
                    iconRight: "-18px",
                  }}
                  id="sponsorImg"
                  image={formik.values.logo}
                  // disabled={!edit}
                  onChange={handleFileUpload}
                  onDelete={handleFileDelete}
                  name="sponsorImg"
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    opacity: "0.5",
                  }}
                >
                  Image must be of resolution 220x220
                </Typography>
                <Box
                  display="flex"
                  flexDirection="column"
                  padding={{ xs: "0", md: "0 20px", width: "100%" }}
                >
                  {loading && <Spinner />}
                  <Typography
                    sx={{
                      fontSize: "18px",
                      minWidth: "300px",
                    }}
                  >
                    Title<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    sx={{
                      marginBottom: "16px",
                    }}
                  >
                    <CustomTextField
                      type="text"
                      placeholder="Title in english"
                      name="en"
                      value={formik.values.en}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      // error={
                      //   formik.touched.title && Boolean(formik.errors.title)
                      // }
                      // errorMessage={formik.touched.title && formik.errors.title}
                    />
                  </Box>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    sx={{
                      marginBottom: "16px",
                    }}
                  >
                    <CustomTextField
                      type="text"
                      placeholder="Title in hindi"
                      name="hi"
                      value={formik.values.hi}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      // error={
                      //   formik.touched.title && Boolean(formik.errors.title)
                      // }
                      // errorMessage={formik.touched.title && formik.errors.title}
                    />
                  </Box>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    sx={{
                      marginBottom: "16px",
                    }}
                  >
                    <CustomTextField
                      type="text"
                      placeholder="Title in french"
                      name="fr"
                      value={formik.values.fr}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      // error={
                      //   formik.touched.title && Boolean(formik.errors.title)
                      // }
                      // errorMessage={formik.touched.title && formik.errors.title}
                    />
                  </Box>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextField
                      type="text"
                      placeholder="Title in spanish"
                      name="es"
                      value={formik.values.es}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      // error={
                      //   formik.touched.title && Boolean(formik.errors.title)
                      // }
                      // errorMessage={formik.touched.title && formik.errors.title}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      minWidth: "300px",
                      maxWidth: "400px",
                      marginTop: "10px",
                    }}
                  >
                    Url<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box
                    borderRadius="40px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <CustomTextField
                      type="text"
                      name="link"
                      placeholder="Enter Url"
                      value={formik.values.link}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.link && Boolean(formik.errors.link)}
                      errorMessage={formik.touched.link && formik.errors.link}
                    />
                    <Typography marginTop={"10px"}>
                      Link/URL should be in the format as
                      https://www.budgetbutterfly.ca
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <DialogActions
              disableSpacing={false}
              sx={{
                ...classes.buttonWrapper,
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              {!isView && (
                <Button
                  style={{ marginTop: 0, width: "50%", minWidth: "150px" }}
                  className="theme-btn-contained theme-btn theme-auth-btn"
                  label={isEdit ? "Update" : "Save"}
                  variant="contained"
                  color="primary"
                  typeButton="submit"
                  disabled={
                    !formik.values.logo ||
                    !formik.values.link ||
                    !formik.values.hi ||
                    !formik.values.en ||
                    !formik.values.fr ||
                    !formik.values.es
                  }
                />
              )}
              <Button
                style={{ marginTop: 0, width: "50%", minWidth: "150px" }}
                className="theme-btn-contained theme-btn theme-auth-btn"
                label={isView ? "Close" : "Cancel"}
                variant="contained"
                color="primary"
                onClick={closeModalHandler}
              />
            </DialogActions>
          </Box>
        </DialogContent>
      </form>
    </CustomDialog>
  );
}
